import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Button from "../button";
import { FormControl } from "../form-control";
import Input from "../input";
import { Form, Formik, FormikContextType } from "formik";
import { createRef } from "react";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Tên là bắt buộc"),
});

function SaveSqlQueryModal({ portalDialogRef }: PortalDialogProps) {
  const formRef = createRef<
    FormikContextType<{
      name: string;
    }>
  >();

  const onSubmit = (values: { name: string }) => {
    portalDialogRef.close(values.name);
  };

  return (
    <Modal onCancel={() => portalDialogRef.close()}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">Lưu câu truy vấn</div>
        <Formik
          innerRef={formRef}
          initialValues={{
            name: "",
          }}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <FormControl name="name">
              <Input className="mt-7" placeholder="Tên câu truy vấn" />
            </FormControl>
            <div className="mt-11 flex justify-center gap-4">
              <Button
                size="xs"
                label="Hủy"
                theme="secondary"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
                onClick={() => portalDialogRef.close()}
              />
              <Button
                type="submit"
                size="xs"
                label="Lưu"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default SaveSqlQueryModal;
